<template>    
    <span v-if="proposal_status === 'complete'">
        <v-btn
        text
        small
        dark
        class="pa-0 mr-4"
        @click="downloadProposalPDF(detail)"        
        >
        Download PDF
        </v-btn>     
        <v-btn
        dark
        small
        text
        class="pa-0"
        @click="downloadProposalDOCX(detail)"
        >
        Download Word
        </v-btn>
    </span>
    <v-btn fab small class="mx-2" elevation=0 v-else-if="proposal_status === 'error'">
        <v-icon color="red" large>mdi-alert-circle-outline</v-icon>
    </v-btn>
    <v-tooltip top v-else>
        <template v-slot:activator="{ on }">
            <v-progress-circular indeterminate color="white" class="mr-2" v-on="on"></v-progress-circular>
        </template>
        <span>Generating Proposal</span>
    </v-tooltip>
</template>

<script>
  import axios from 'axios';
  import {mapActions} from 'vuex';
  export default {
    
    data: () => ({
       proposal_status: '',
       intervalCreated: false,
       interval: null,
    }),  
      
    props: {
        status: [String],
        id: [ Number, String],
        detail: [Object],
    },
    
    mounted () {
        this.proposal_status = this.status;
    },
    
    beforeDestroy() {
        this.removeInterval();
    },
    
    computed: {
        
         mobile () {
            switch (this.$vuetify.breakpoint.name) {
              case 'xs': return true;
              case 'sm': return true;
              case 'md': return false;
              case 'lg': return false;
              case 'xl': return false;
            }
            return null
        },
        
        
    },
    watch: {
        proposal_status: {
            handler: function(new_value) {
                console.log(new_value)
                if(new_value !== "complete" && new_value != "error"){
                    this.createInterval();
                } else {
                    this.removeInterval();
                }
            }
        }
    },
    methods: {
        ...mapActions(['downloadProposalPDF', 'checkQueue', 'downloadProposalDOCX']),
        
        createInterval(){
            console.log('createInterval');
            if(!this.intervalCreated){
                // this.queueCheck();
                this.interval = setInterval(() => {
                    this.queueCheck();
                }, 1000);
            }
            // console.log('value set')
            this.intervalCreated = true;
        },
        
        queueCheck() {
            let token = sessionStorage.getItem('token');
            let authToken = "Token "+token;
            let authHeader = {headers: {
                Authorization: authToken
            }};
            axios.get('proposal/queue/?proposal_id='+ this.id, authHeader).then((res) => {
                this.proposal_status = res.data.queue_status
            })
            .catch(err => {
                console.log(err)
                this.proposal_status = 'error'
            })
        },

        removeInterval(){
            this.intervalCreated = false;
            clearInterval(this.interval);
        },

        uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
    },
    components: {}
  };
</script>

<style type="text/css" scoped>
    .border {
      border-style: solid !important;
    }
    .v-data-table__expanded__content{
        box-shadow: none;
    }
    .row_item {
        border-bottom: thin solid rgb(0,0,0,30%);
    }
    button.theme--dark.v-btn {
        color: #444 !important;
    }
    div[role=progressbar] {
        color: #444 !important;
        height:20px !important;
        width:20px !important;
    }
</style>